import { colorsPalettes } from "@similarweb/styles";

import { ONBOARDING_AGENT_AI_GRADIENT_COLORS } from "../onboardingAgentAiGradientTokens";

import { TRIGGER_ICON_SIZE_PX } from "./constants";
import { AnimatedSparklePath } from "./styles";

type TriggerAiBotIconProps = {
    gradientId: string;
    isBouncing?: boolean;
};

export const TriggerAiBotIcon = ({ gradientId, isBouncing = false }: TriggerAiBotIconProps) => (
    <svg
        width={TRIGGER_ICON_SIZE_PX}
        height={TRIGGER_ICON_SIZE_PX}
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        focusable="false"
    >
        <g>
            <path
                d="M31.0008 1.5C33.2097 1.50026 35.0008 3.29102 35.0008 5.5V24.5C35.0008 26.709 33.2097 28.4997 31.0008 28.5H18.7499L10.2743 35.0195C9.75375 35.4199 9.00012 35.0492 8.99986 34.3926V28.5H7.00083C4.79169 28.5 2.99986 26.7091 2.99986 24.5V5.5C2.99986 3.29086 4.79169 1.5 7.00083 1.5H31.0008Z"
                fill={colorsPalettes.carbon[0]}
            />
            <AnimatedSparklePath
                d="M21.5 12.5L19 7L16.5 12.5L11 15L16.5 17.5L19 23L21.5 17.5L27 15L21.5 12.5Z"
                fill={`url(#${gradientId})`}
                $isBouncing={isBouncing}
            />
        </g>
        <defs>
            <linearGradient
                id={gradientId}
                x1="3.41565"
                y1="18.3426"
                x2="35.0155"
                y2="18.349"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor={ONBOARDING_AGENT_AI_GRADIENT_COLORS.triggerStart} />
                <stop
                    offset={1}
                    stopColor={ONBOARDING_AGENT_AI_GRADIENT_COLORS.triggerEnd}
                />
            </linearGradient>
        </defs>
    </svg>
);
